import styled from "styled-components";

import { pageRoot } from "../../styles/pageRoot";
import {
  AdminContentCard,
  AdminHeaderRow,
  AdminSearchBar,
  StatusBadge as SharedStatusBadge,
} from "../../styles/adminPage";
import { md3CardRadius } from "../../shared/styles/md3Components";

export const Container = styled.div`
  ${pageRoot}
  background: ${({ theme }) => theme.colors.layoutBg};
`;

export const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 max(1.2rem, env(safe-area-inset-left)) 0
    max(1.2rem, env(safe-area-inset-right));
  background: none;
  width: 100%;
  max-width: ${({ theme }) => theme.layout.contentStandardPx}px;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const SearchBar = styled(AdminSearchBar)`
  width: 100%;
  margin-top: -1.2rem;
`;

export const Content = styled(AdminContentCard)`
  width: 100%;
  margin-top: 2.4rem;
`;

export const HeaderContent = styled(AdminHeaderRow)``;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: ${({ theme }) => md3CardRadius(theme)}px;

  .ant-table {
    font-size: 19px;
    background: transparent;
  }
`;

export const StatusBadge = SharedStatusBadge;
